import http from './http'

const basePath = '/achievement/patent'

const normalizeBody = (idOrPayload, payload) =>
  typeof idOrPayload === 'object' && idOrPayload !== null ? idOrPayload : { ...(payload || {}), id: idOrPayload }

const withId = (id) => `${basePath}/${id}`

export async function savePatent(payload) {
  const res = await http.post(`${basePath}/saveDraft`, payload)
  return res.data
}

export async function submitPatent(payload) {
  const res = await http.post(`${basePath}/submit`, payload)
  return res.data
}

export async function createPatent(payload) {
  return payload?.isDraft ? savePatent(payload) : submitPatent(payload)
}

export async function updatePatent(idOrPayload, payload) {
  const body = normalizeBody(idOrPayload, payload)
  if (typeof body?.isDraft === 'boolean') {
    return body.isDraft ? savePatent(body) : submitPatent(body)
  }
  const res = await http.put(basePath, body)
  return res.data
}

export async function getPatent(id) {
  const res = await http.get(withId(id))
  return res.data
}

export async function listPatents(params) {
  const res = await http.get(basePath, { params })
  return res.data
}

export async function deletePatent(id) {
  const res = await http.delete(withId(id))
  return res.data
}
